import { NewSubjectChapterPage } from "./ChapterPage";
export default NewSubjectChapterPage;
